export const useIsScratchcardEnabled = () => useIsFeatureFlagEnabled('scratchcards')
